import { customElement } from 'lit/decorators.js';
import { BaseComponent } from '../base-component/base-component';
import { SSOFromWindow } from './browse-context/direction/from-window/sso-from-window.service';
import { SSOUtils } from './utils/sso.utils';
import { html } from 'lit';

@customElement('mhecomm-sso-proxy')
export class SSOProxy extends BaseComponent {
  connectedCallback(): void {
    super.connectedCallback();
    new SSOFromWindow(new SSOUtils()).postReadyToSSO('boardsbeyond', '*');
  }

  renderComp() {
    return html`<p>Authenticating...</p>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-sso-proxy': SSOProxy;
  }
}
